import React, { useState, useEffect, useRef } from "react";
import ExecutiveOverview from "./MarketPositionBenchmarkHBFULLER/ExecutiveOverview";
import MarketPosition from "./MarketPositionBenchmarkHBFULLER/MarketPosition";
import CustomerIntelligence from "./MarketPositionBenchmarkHBFULLER/CustomerIntelligence";
import { ChevronLeft, ChevronRight, Eye, Target, Heart } from "react-feather";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MarketPositionNew.css";

const MarketPositionHBFULLER = ({ activeSubKey, setActiveSubKey }) => {
  const [currentSection, setCurrentSection] = useState(1);
  const [completedSections, setCompletedSections] = useState([]);

  const executiveOverviewMpNewRef = useRef(null);
  const marketPositionNewRef = useRef(null);
  const customerIntelligenceRef = useRef(null);
  const programmaticScrollRef = useRef(false);

   const sectionMap = {
    executiveOverviewMpNewTab: executiveOverviewMpNewRef,
    marketPositionNewTab: marketPositionNewRef,
    customerIntelligenceTab: customerIntelligenceRef,
  };

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  useEffect(() => {
    if (!activeSubKey) return;

    const sectionRef = sectionMap[activeSubKey];
    if (sectionRef?.current) {
      // mark as programmatic scroll so scroll-spy ignores this movement
      programmaticScrollRef.current = true;

      const yOffset = -100;
      const y =
        sectionRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });

      // clear the flag after animation; tune timeout to match your animation time
      const t = setTimeout(() => {
        programmaticScrollRef.current = false;
      }, 700);

      return () => clearTimeout(t);
    }
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL

  useEffect(() => {
    let scrollTimeout = null;
    let ticking = false;

    const handleScroll = () => {
      if (programmaticScrollRef.current) return; // ignore programmatic scrolls
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        // Clear previous timeout (debounce)
        if (scrollTimeout) clearTimeout(scrollTimeout);

        // Wait until user stops scrolling for 200ms
        scrollTimeout = setTimeout(() => {
          const scrollPosition = window.scrollY + 120; // offset for header, etc.
          let currentKey = null;

          Object.entries(sectionMap).forEach(([key, ref]) => {
            if (!ref.current) return;
            const sectionTop = ref.current.offsetTop;
            const sectionHeight = ref.current.offsetHeight;

            // Check if scroll is within this section
            if (
              scrollPosition >= sectionTop &&
              scrollPosition < sectionTop + sectionHeight
            ) {
              currentKey = key;
            }
          });

          // update nav only if different
          if (currentKey && currentKey !== activeSubKey) {
            setActiveSubKey(currentKey);
          }
        }, 200); // change nav only after 200ms of no scrolling

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // run once on mount
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  const sections = [
    { id: 1, title: "Executive Overview", icon: Eye },
    { id: 2, title: "Market Position", icon: Target },
    { id: 3, title: "Customer Intelligence", icon: Heart },
  ];

  const handleNext = () => {
    if (!completedSections.includes(currentSection)) {
      setCompletedSections([...completedSections, currentSection]);
    }
    if (currentSection < 3) {
      setCurrentSection(currentSection + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrevious = () => {
    if (currentSection > 1) {
      setCurrentSection(currentSection - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleJumpToSection = (sectionId) => {
    setCurrentSection(sectionId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div className="min-vh-100 bg-light">
      <style>{`
        .section-btn {
          flex: 1;
          padding: 12px;
          border-radius: 0.5rem;
          transition: all 0.3s ease;
          border: 2px solid transparent;
          display:flex;
          align-item:center;
          text-align:center;
        }
        .section-btn-current {
          background: #0d6efd;
          color: #fff;
          box-shadow: 0 4px 6px rgba(13,110,253,0.3);
        }
        .section-btn-completed {
          background: #d1e7dd;
          color: #0f5132;
        }
        .section-btn-completed:hover {
          background: #a3cfbb;
        }
        .section-btn-pending {
          background: #e9ecef;
          color: #6c757d;
        }
        .section-btn-pending:hover {
          background: #dee2e6;
        }
        .nav-button {
          padding: 8px 10px 8px 10px;
          color: #fff !important;
          font-family: Inter;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          border: none;
          min-width: 100px;
          border-radius: 8px;
        }
        .nav-button:disabled {
          background: #BABFCC;
          color: #adb5bd;
          cursor: not-allowed;
        }
        .nav-button-prev:not(:disabled) {
          background: #BABFCC;
          color: #fff;
        }
        .nav-button-prev:not(:disabled):hover {
          background: #343a40;
        }
        .nav-button-next:not(:disabled) {
          background: #4E6BCA;
          color: #fff;
        }
        .nav-button-next:not(:disabled):hover {
          background: #0b5ed7;
        }
      `}</style>

      {/* Header - NOT STICKY */}
      <div className="bg-white shadow-sm border-bottom market_new_position_wrapper">
        <div className="container py-3 bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="main_head">
              Competitive Benchmarking - Market Position & Customer Intelligence
            </h1>
            <div className="section_number">
              Section {currentSection} of {sections.length}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-4 bg-white">
        {/* {renderCurrentSection()} */}
        {/* <> */}
        <div ref={executiveOverviewMpNewRef}>
          <ExecutiveOverview />
        </div>
        <div ref={marketPositionNewRef}>
          <MarketPosition />
        </div>
        <div ref={customerIntelligenceRef}>
          <CustomerIntelligence />
        </div>
      </div>
    </div>
  );
};

export default MarketPositionHBFULLER;
